import { render, staticRenderFns } from "./WhatsappCampaignDetails.vue?vue&type=template&id=25e26c1c"
import script from "./WhatsappCampaignDetails.vue?vue&type=script&lang=js"
export * from "./WhatsappCampaignDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports